import React, { useEffect, useState } from "react";
import { Box, Button, Container, Divider, Grid, Toolbar, AppBar, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { ModalUnstyled } from "../modal/Modal";
import { StoreCard } from "../components/StoreCard";
import { useLocalStorage } from "../hooks/useLocalStorage";
import MultiStepForm from "../Forms/MultiStepPayFrom";
import Footer from "./homepage/components/Footer";

export const StoreSelect = () => {
    const { Logout, user, listStore, updateStoreList } = useAuth();
    const [showModaladd1, setshowModaladd1] = useState(false);

    const [da, setda] = useLocalStorage('da', null);
    const [, setStore] = useLocalStorage('ds', null);
    const navigate = useNavigate();

    useEffect(() => {
        if (!user) {
            navigate("/login", { replace: true });
        }
        if (da >= 0 && da !== null) {
            navigate("/admin", { replace: true });
        }
        updateStoreList();
        // eslint-disable-next-line
    }, [da, user, navigate]);

    const cardActionHandler = async (type, storeid) => {
        setda(type);
        await setStore(storeid);
        if (da >= 0) {
            navigate("/admin", { replace: true });
        }
    }

    return (
     
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            
            <AppBar position="fixed" sx={{ background: '#1a1b2f' }} elevation={2}>
                <Toolbar sx={{ justifyContent: 'space-between' }}>
                    <Typography 
                        variant="h6" 
                        onClick={() => { navigate("/") }} 
                        sx={{ cursor: 'pointer' }}
                    >
                        MiiRA POS
                    </Typography>
                    <Box>
                        <Button 
                            sx={{ background: 'tomato', color: '#fff', px: 2, py: 1 }}
                            key={'Logout-0'} 
                            onClick={() => Logout()}
                        >
                            LogOut
                        </Button>
                    </Box>
                </Toolbar>
            </AppBar>

      
            <Box component="main" sx={{ flexGrow: 1, p: 2 }}>
                
             
                <Toolbar /> 

                <Container maxWidth="lg">
                    <Box sx={{ mb: 2 }}>
                        {/* 3. Responsive Header Grid */}
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={8}>
                                <Typography variant="h5" component="h3" sx={{ fontWeight: 'bold' }}>
                                    STORE LIST
                                </Typography>
                            </Grid>
                            
                           
                            <Grid item xs={12} sm={4} sx={{ textAlign: { xs: 'left', sm: 'right' } }}>
                                <Button 
                                    variant="contained" 
                                    fullWidth={false} 
                                    onClick={() => setshowModaladd1((prev) => !prev)}
                                >
                                    + Add Store
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>

                    <Divider sx={{ marginBottom: "25px" }} />

                    <Box>
                        <Grid container spacing={3}>
                            {listStore.length > 0 ? (
                                listStore.map((store) => (
                                
                                    <Grid item xs={12} sm={6} md={4} key={'grid-' + store.storeid}>
                                        <StoreCard 
                                            key={'ss' + store.storeid} 
                                            storeName={store.name} 
                                            storeid={store.storeid} 
                                            type={store.type} 
                                            address={store.address} 
                                            setda={setda} 
                                            setStore={setStore} 
                                            cardActionHandler={cardActionHandler} 
                                        />
                                    </Grid>
                                ))
                            ) : (
                                <Grid item xs={12}>
                                    <Typography align="center" variant="body1" color="textSecondary">
                                        NO Data From Server
                                    </Typography>
                                </Grid>
                            )}
                        </Grid>
                    </Box>

                    <ModalUnstyled
                        shouldShow={showModaladd1}
                        onRequestClose={() => setshowModaladd1((prev) => !prev)}
                    >
                        <MultiStepForm setshowModaladd={setshowModaladd1} />
                    </ModalUnstyled>
                </Container>
            </Box>

            {/* 5. Footer remains at bottom naturally */}
            <Box component="footer" sx={{ py: 2, bgcolor: 'background.paper' }}>
                <Footer />
            </Box>
        </Box>
    );
}